// 원활한 에러핸들링을 위해 에러메시지를 폐기하고 에러코드 도입
export enum ErrorCode {
  IDF = 'IDF', // Invalid Dto Field
  RVN = 'RVN', // Required Value Null
  ENF = 'ENF', // Enum Not Found
  NFR = 'NFR', // Not Found Result
  NAU = 'NAU', // Not Authorized User
  UAA = 'UAA', // Unauthorized Access
  AEV = 'AEV', // Already Exist Value
  AEV_EMAIL = 'AEV_EMAIL', // Already Exist Email
  AEV_HANDLE = 'AEV_HANDLE', // Already Exist Handle
  
  ATX = 'ATX', // Access Token Expired
  RTX = 'RTX', // Refresh Token Expired
  UME = 'UME', // UnManaged Error

  AWS = 'AWS', // Error about AWS

  DUK = 'DUK',  // Duplicated Unique Key
  DBE = 'DBE',   // Database Error

  WEF = 'WEF',  // Wrong Error Format

  BFE = 'BFE', // Big File Error
  NCE = 'NCE', // Network Connection Error
  SDN = 'SDN', // Server Down
  EME = 'EME', // EMail send Error
  EVF = 'EVF', // Email verification Failed
  MIA = 'MIA', // Member Inactive
  MPA = 'MPA', // Member Pending Approval
  MVE = 'MVE', // Member Verification Error

  VIE = 'VIE', // Verification Invalid Error
  VEE = 'VEE', // Verification Expired Error
  VAE = 'VAE', // Verification Already Exist

  TLX = 'TLX', // Text Length Exceeded
  LME = 'LME', // Limit Exceeded
  WLW = 'WLW', // WaitList Waiting
  WLP = 'WLP', // WaitList Proposal
  IVP = 'IVP', // Invalid Password
  GML_MEMBER_NOT_FOUND = 'GML_MEMBER_NOT_FOUND',
  GML_GROUP_ACCOUNT = 'GML_GROUP_ACCOUNT',
  GML_INVALID_PASSWORD = 'GML_INVALID_PASSWORD',
  GML_ALREADY_LINKED = 'GML_ALREADY_LINKED',
  GML_PASSWORD_NOT_SET = 'GML_PASSWORD_NOT_SET',
  GML_LINK_TOKEN_EXPIRED = 'GML_LINK_TOKEN_EXPIRED',
  GML_LINK_TOKEN_INVALID = 'GML_LINK_TOKEN_INVALID',
  GML_LINK_TARGET_MISMATCH = 'GML_LINK_TARGET_MISMATCH',
  GML_PROFILE_CHANGED = 'GML_PROFILE_CHANGED',
  USX_NONE = 'USX_NONE', // User Storage Exceeded - free tier (500MB cap)
  USX_ACTIVE = 'USX_ACTIVE', // User Storage Exceeded - subscribed member
}

export const convertStringToErrorCode = (code: string): ErrorCode => {
  if (code in ErrorCode) {
    return ErrorCode[code as keyof typeof ErrorCode];
  } else {
    return ErrorCode.WEF;
  }
}
